export default {
  path: 'excavation-service/excavation-settings/quarters',
  name: 'ExcavationSettingsQuarters',
  meta: {
    title: 'road-maintenance/dropdown-types.city_district',
    create_title: 'road-maintenance/excavation-dropdown-type.create_city_district',
    edit_title: 'road-maintenance/excavation-dropdown-type.edit_city_district',
    delete_title: 'road-maintenance/excavation-dropdown-type.delete_city_district',
    confirm_delete: 'road-maintenance/excavation-dropdown-type.confirm_delete_city_district',
    import_title: 'road-maintenance/excavation-dropdown-type.import_city_district',
    name_label: 'road-maintenance/excavation-dropdown-type.city_district_name',
    name: 'CITY_DISTRICT'
  },
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/ExcavationSettingsIndex')
}
